<template>
  <div class="modal fade" id="AddUsagerModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="AddUsagerModalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Usager</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="usagerForm" @submit="soumettre" :validation-schema="usagerSchema">
            <div class="row">
              <div class="col-md-3 col-sm-12 col-xs-12 col-lg-3 col-xl-3 col-xxl-3">
                <div class="upload-container">
                  <input type="file" name="urlImage" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                    accept="image/*" hidden />
                  <div class="preview-card" @click="triggerFileInput">
                    <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                    <div v-else class="text-center">
                      <div>
                        <i class="flaticon-camera fs-1"></i>
                      </div>
                      Cliquez pour ajouter l'image principal du produit
                    </div>
                    <button v-if="imagePreview" class="delete-btn" @click.stop="removeImage"><i
                        class="flaticon-close"></i></button>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-sm-12 col-xs-12 col-lg-9 col-xl-9 col-xxl-9">
                <div class="row">

                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="d-block text-black fw-semibold">
                        Nom <span class="text-danger"></span>
                      </label>
                      <Field name="nom" v-model="nom" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Renseigner le nom" />
                      <ErrorMessage name="nom" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="d-block text-black fw-semibold">
                        Prénom <span class="text-danger"></span>
                      </label>
                      <Field name="prenom" type="text" v-model="prenom"
                        class="form-control shadow-none fs-md-15 text-black" placeholder="Renseigner le prénom" />
                      <ErrorMessage name="prenom" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group mb-15">
                      <label class="d-block text-black fw-semibold">
                        Date de naissance <span class="text-danger"></span>
                      </label>
                      <Field name="dateNaissance" v-model="dateNaissance" type="date"
                        class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Renseigner votre date de naissance" />
                      <ErrorMessage name="dateNaissance" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="d-block text-black fw-semibold">
                        NIP <span class="text-danger"></span>
                      </label>
                      <Field name="npi" v-model="nip" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Renseigner le NPI" />
                      <ErrorMessage name="npi" class="text-danger" />
                    </div>
                  </div>

                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="d-block text-black fw-semibold">
                        Adresse <span class="text-danger"></span>
                      </label>
                      <Field name="adresse" v-model="adresse" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Renseigner l'adresse" />
                      <ErrorMessage name="adresse" class="text-danger" />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="d-block text-black fw-semibold">
                        Téléphone <span class="text-danger"></span>
                      </label>
                      <Field name="tel" v-model="telephone" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="Renseigner l'adresse" />
                      <ErrorMessage name="tel" class="text-danger" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    IFU <span class="text-danger"></span>
                  </label>
                  <Field name="ifu" v-model="ifu" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="XXXXXXXXXXXX" />
                  <ErrorMessage name="ifu" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label fw-medium text-black"> Sexe </label>
                  <Field name="sexe" v-slot="{ field }" v-model="sexe">
                    <Multiselect :options="sexes" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner un sexe" />
                  </Field>
                  <ErrorMessage name="sexe" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label fw-medium text-black">
                    Activite
                  </label>
                  <Field name="activite" v-slot="{ field }" v-model="activite">
                    <Multiselect :options="activites" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner une activité" />
                  </Field>
                  <ErrorMessage name="activite" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Plus detail activité <span class="text-danger"></span>
                  </label>
                  <Field name="nouveau_activite" v-model="nouveau_activite" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Tomate" />
                  <ErrorMessage name="nouveau_activite" class="text-danger" />
                </div>
              </div>

              <div class="col-md-12 mt-5">
                <div class="product-upload mb-10">
                  <!--<p>Images</p>-->
                  <div class="dz-message needsclick">
                    <DropZone name="fichiers[]" :maxFilesize="50" :maxFiles="30"
                      :uploadOnDrop="true" @addedFile="onFileAdd" @removedFile="onFileRemove" :options="dropzoneOptions"
                      @vdropzone-success="onSuccess" @vdropzone-error="onError">
                      <div class="default-image-container" v-if="!hasFiles">
                      <img :src="defaultImage" alt="Default" class="default-image" />
                      <p>Glissez et dépossez ici</p>
                      </div>
                    </DropZone>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
                <button type="submit" class="btn btn-primary w-100">
                  Enregistrer
                </button>
              </div>
            </div>
          </Form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive } from "vue";
import { Form, Field, ErrorMessage, useResetForm } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import { Option } from "@/models/Option";
import { hideModal, showModal, success, error, reformat_Date, getUrlApiForFiles } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";
import ApiService from "@/services/ApiService";
import JwtService from "@/services/JwtService";
import DropZone from "dropzone-vue";


export default defineComponent({
  name: "AddUsagerModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    DropZone
  },
  props: {
    item: {
      type: String,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const usagerSchema = Yup.object().shape({
      nom: Yup.string().required("Le nom est obligatoire"),
      prenom: Yup.string().required("Le prénom est obligatoire"),
      tel: Yup.string().notRequired(),
      sexe: Yup.string().notRequired(),
      nouveau_activite:Yup.string().notRequired(),
      adresse: Yup.string().notRequired(),
      ifu: Yup.string()
        .nullable() // Rendre le champ ifu optionnel
        .test("len", "Le IFU doit faire exactement 13 caractères", (value) => {
          // Si `ifu` est renseigné, vérifier qu'il fait bien 13 caractères
          return !value || value.length === 13;
        }),
      npi: Yup.string()
        .nullable()
        .test("len", "Le NIP doit faire exactement 10 caractères", (value) => {
          return !value || value.length === 10;
        }),
      dateNaissance: Yup.date().notRequired(),
      activite: Yup.string().required("L'activité est obligatoire"),
    });

    const usagerForm = ref<any | null>(null);
    const ifu = ref();
    const nom = ref();
    const prenom = ref();
    const nip = ref();
    const nouveau_activite = ref();
    const dateNaissance = ref();
    const adresse = ref();
    const mois = ref();
    const sexe = ref();
    const activite = ref();
    const matricule = ref<any>(null);
    const telephone = ref();
    const moiss = ref();
    const AddUsagerModalRef = ref<null | HTMLElement>(null);
    const defaultImage = ('/public/welcome2.png'); // Chemin de l'image par défaut
    const hasFiles = ref(false);
    const toutFichier = ref<Array<File>>([]);
    const sexes = ref([
      { value: "Masculin", label: "Masculin" },
      { value: "Féminin", label: "Féminin" },
      { value: "Autre", label: "Autre" },
    ]);

    const resetForm = () => {
      ifu.value = "";
      nom.value = "";
      prenom.value = "";
      nip.value = "";
      adresse.value = null;
      telephone.value = null;
      sexe.value = null;
      dateNaissance.value = null;
      matricule.value = null;
    };

    const getUsager = async (matricule: string) => {
      try {
        const response = await axios.get(`usager/${matricule}`);
        imagePreview.value = "";
        imageFile.value = null;
        toutFichier.value = [];
        if (response.data.data) {
          const lusager = response.data.data;
          const photoMedia = lusager.medias.find(media => media.typeFichier === "Photo");
          if (photoMedia) {
            imagePreview.value = await getUrlApiForFiles("Usagers", photoMedia.nomMedia);
          }
          ifu.value = lusager.ifu;
          nom.value = lusager.nom;
          prenom.value = lusager.prenom;
          nip.value = lusager.npi;
          adresse.value = lusager.adresse;
          telephone.value = lusager.tel;
          sexe.value = lusager.sexe;
          dateNaissance.value = reformat_Date(lusager.date_naissance); //new Date();
          activite.value = lusager.new_activite;
          imagePreview.value = lusager.urlImage;
        } else {
          error("Erreur lors de la récupération de l'usager");
        }
      } catch (err) {
        //
      }
    };

    const activites = ref([]);
    const reupererActivite = async () => {
      try {
        const response = await ApiService.get("listeActivite");
        if (response.data) {
          return (activites.value = response.data.data.map((el) => {
            return {
              value: el.activite_nom,
              label: el.activite_nom,
            };
          }));
        }
      } catch (err) {
        error(err);
      }
    };

    watch(
      () => props.item,
      async (newValue) => {
        await reupererActivite();
        if (newValue !== null) {
          matricule.value = newValue;
          await getUsager(newValue);
        } else {
          resetForm();
        }
      }
    );

    const soumettre = async (values, { resetForm }) => {
     // values["userCreaionId"] = JwtService.getUser();
     values["userCreation"] = JwtService.getUser();
      values["matricule"] = matricule.value;
      values['autreFichier[]'] = [];
      values["urlImage"] = [];
      if (toutFichier.value.length > 0) {
        values['autreFichier[]'] = toutFichier.value;
      }
      if (imageFile.value) {
        values["urlImage"] = imageFile.value;
      }
      try {
        const response = await axios.post("usager/creation", values, {
          headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
        });
        if (matricule.value) {
          success("L'usager a été modifié avec succès");
        } else {
          success("L'usager a été enregistré avec succès");
        }
        resetForm();
        hideModal(AddUsagerModalRef.value);
        emit("close");
      } catch (err) {
        //
        if (err instanceof AxiosError) {
          error(err.response?.data?.message);
        } else {
          error("Une erreur est survenue");
        }
      }
    };
    const fileInput = ref();
    const imagePreview = ref<string | null>(null);
    const imageFile = ref(null);
    const triggerFileInput = () => {
      fileInput.value.click();
    };

    const onFileAdd = (file: any) => {
      toutFichier.value.push(file["file"]);
      hasFiles.value = true;
    };

    const onFileRemove = (file: File) => {
      const index = toutFichier.value.findIndex(fil => ((fil.name === file["file"].name) && (fil.size === file["file"].size) && (fil.type === file["file"].type)));
      if (index !== -1) {
        toutFichier.value.splice(index, 1);
      } else {
        //
      }
      hasFiles.value = toutFichier.value.length > 0;
    };
    const images = reactive([
      {
        file: null as File | null,
        previewUrl: null as string | null,
      },
    ]);


    const dropzoneOptions = {
      url: '/public/welcome2.png', // URL de téléchargement des fichiers
      thumbnailWidth: 150,
      maxFilesize: 50, // Taille maximale du fichier en Mo
      maxFiles: 10, // Nombre maximal de fichiers
      headers: { "My-Awesome-Header": "header value" },
      acceptedFiles: ".jpg,.png,.pdf",
    };
    const onSuccess = (file) => {
      //
    };

    const onError = (file, message) => {
      console.error('Erreur de téléchargement:', message);
    };

    const onFilePrinChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target) {
            imagePreview.value = e.target.result as string;
          }
        };
        reader.readAsDataURL(file);
      }
    };

    const removeImage = () => {
      imagePreview.value = null;
      imageFile.value = null;
    };

    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      if (file) {
        images[index].previewUrl = URL.createObjectURL(file);
        images[index].file = file;
      }
    };

    return {
      nouveau_activite,
      props,
      fileInput,
      imagePreview,
      imageFile,
      triggerFileInput,
      onFileChange,
      removeImage,
      ifu,
      nom,
      onSuccess,
      onError,
      dropzoneOptions,
      images,
      onFileRemove,
      onFileAdd,
      prenom,
      defaultImage,
      nip,
      adresse,
      sexes,
      AddUsagerModalRef,
      sexe,
      mois,
      moiss,
      soumettre,
      usagerSchema,
      telephone,
      usagerForm,
      dateNaissance,
      onFilePrinChange,
      activite,
      activites,
      hasFiles,
    };
  },
});
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 240px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 250px;
  height: auto;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  padding: 5px 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.delete-btn:hover {
  background: darkred;
}
</style>